import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import Iconify from '../../../../reusable-components/iconify';
import { fCurrency } from '../../../../utils/formatNumber';

OrderReviewerTooltipText.propTypes = {
  reviewer: PropTypes.object.isRequired,
  department: PropTypes.string,
}

export default function OrderReviewerTooltipText({ reviewer, department }) {

  return (
    <Typography variant="caption">
      {!!reviewer.required && <Box sx={{ display: 'flex', alignItems: 'center', }}>
        <Iconify icon="mynaui:asterisk-circle" color="white" width={12} sx={{ mr: 1 }} />
        Review is required</Box>}
      {!!reviewer.minimum && <Box sx={{ display: 'flex', alignItems: 'center', }}>
        <Iconify icon="lsicon:amount-dollar-outline" color="white" width={12} sx={{ mr: 1 }} />
        Order is over {fCurrency(reviewer.minimum)}</Box>}
      {!!reviewer.budget && <Box sx={{ display: 'flex', alignItems: 'center', }}>
        <Iconify icon="tabler:calendar-dollar" color="white" width={12} sx={{ mr: 1 }} />
        Order is over the {reviewer.budget} budget</Box>}
      {!!reviewer.agoraCategories?.length && <Box sx={{ display: 'flex', alignItems: 'center', }}>
        <Iconify icon="tabler:category-plus" color="white" width={12} sx={{ mr: 1 }} />
        Order is in the {department} category</Box>}
    </Typography>
  )
}
